(function () {

    'use strict';

    angular.module('iplusjs.validator.add', [
        'iplusjs.validator.group',
        'iplusjs.utils.misc',
        'iplusjs.fieldset'
    ])
        .directive('iplusjsValidatorAdd', validatorAdd);

    validatorAdd.$inject = [
        '$log',
        'MiscUtilsService'
    ];
    function validatorAdd($log, MiscUtilsService) {
        return {
            restrict: 'A',
            require: ['ngModel', '^iplusjsValidatorGroup', '^?iplusjsFieldset'],
            link: function ($scope, $elem, $attrs, ctrls) {
                var $ngModel = ctrls[0],
                    validatorGroupCtrl = ctrls[1],
                    fieldsetCtrl = ctrls[2],
                    includeDisabled = MiscUtilsService.isEmpty($attrs.ivaIncludeDisabled) ? false : $scope.$eval($attrs.ivaIncludeDisabled);

                if ((($attrs.disabled || $scope.$eval($attrs.ngDisabled)) || (fieldsetCtrl && fieldsetCtrl.disabled)) && !includeDisabled) {
                    return;
                }

                validatorGroupCtrl.addItem({
                    $scope: $scope,
                    $elem: $elem,
                    $ngModel: $ngModel,
                    $attrs: $attrs,
                    modelPropName: $attrs.iplusjsValidatorAdd
                });
            }
        };
    }
})();
